/* eslint-disable import/prefer-default-export */
export const Errors = {
  listErrorsRequest: 'LIST_ERRORS_PENDING',
  listErrorsSuccess: 'LIST_ERRORS_SUCCESS',
  listErrorsError: 'LIST_ERRORS_ERROR',
};
